import React from 'react'
import JobHeader from './JobHeader'
import SideBar from './SideBar'
import Recruitment from './Recruitment.js'
import { Link } from 'react-router-dom'
import './JobProcess.css'
export default function JobProcess() {
  return (
   
        <Recruitment/>
  )
}
